export const getBaseUrl = (url: string) => {
  const baseUrlMatch = url.match(/^(https?:\/\/[^/]+)/);
  if (baseUrlMatch) {
    return baseUrlMatch[0];
  }

  return url;
};
